import { useContext, useEffect, useState } from "react"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { WebSocketContext } from "../../../../../../Providers/WebSocket/WebSocketContext"
import { Button, Typography } from "@mui/material"
import OneInput from "../../../../../../Components/OneInput/OneInput"
import OneModal from "../../../../../../Components/OneModal/OneModal"
import { OneSwitch } from "../../../../../../Components/OneSwitch/OneSwitch"
import { showNotify } from "../../../../../../Utils/Utils"

const EdicaoAutomacao = ({ idToEdit, idCentral, openAutomacao, setOpenAutomacao }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const [formData, setFormData] = useState(null)
    const [initialData, setInitialData] = useState()

    const getAutomacao = (msg) => {
        if (msg.data.status) {
            setInitialData(msg.data.automacao)
        }
    }

    useEffect(() => {
        addRoute("buscarAutomacao", getAutomacao)
        let stringId = idToEdit != null ? `${idToEdit}` : null
        sendWs("buscarAutomacao", { id: stringId, condId: idCentral })
    }, [])

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const responseSumbit = (msg) => {
        if (msg.data.status == "error") {
            showNotify("error", msg.data.message)
        } else if (msg.data.status) {
            showNotify("success", "Dados salvos com sucesso!")
            setOpenAutomacao(false)
            sendWs("buscarTodasAutomacoes", { condId: idCentral })
        } else if (!msg.data.status) {
            showNotify("error", msg.data.message)
        }
    }

    addRoute("editarAutomacao", responseSumbit)

    const handleSubmit = async (event) => {
        event.preventDefault()

        if (!formData) {
            showNotify("warning", "Nenhuma alteração feita!")
            return
        }

        let data = formData

        if (initialData?.id != null) {
            const newData = { id: initialData?.id }
            for (const prop in initialData) {
                if (Object.hasOwnProperty.call(initialData, prop)) {
                    if (initialData[prop] != data[prop] && data[prop] != undefined) {
                        newData[prop] = data[prop]
                    }
                }
            }
            data = newData

            sendWs("editarAutomacao", { automacao: data })
        }
    }

    return (
        <OneModal
            open={openAutomacao}
            setOpen={setOpenAutomacao}
            titleText="Editar Automacao"
            FooterButtons={FooterButtons}
            fullWidth={true}
            onClose={false}
        >
            <form
                id="automacao-form"
                onSubmit={handleSubmit}
                style={{ width: '100%' }}
            >
                {initialData &&
                <Grid xs={12} sx={{ alignItems: 'center' }}>
                    <Grid container xs py={0.5} sx={{ alignItems: 'center' }}>
                        <Grid md>
                            <Grid container xs={7} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={1.7}>
                                    <Typography fontSize="13px" fontWeight='400' >Descrição: </Typography>
                                </Grid>
                                <Grid xs={12} md={9.5}>
                                    <OneInput
                                        defaultValue={initialData?.descricao}
                                        maxLength="255"
                                        required
                                        onChange={handleChange}
                                        name={"descricao"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md={3}>
                            <Grid xs={7} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md>
                                    <OneSwitch
                                        defaultValue={initialData?.visivel}
                                        onChange={handleChange}
                                        name={"visivel"}
                                    />
                                </Grid>
                                <Grid xs={12} md={10}>
                                    <Typography fontSize="13px" fontWeight='400' >Visível Monitoramento </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container xs py={0.5} sx={{ alignItems: 'center' }}>
                        <Grid md={3.5}>
                            <Grid xs={7} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md>
                                    <OneSwitch
                                        defaultValue={initialData?.morador}
                                        onChange={handleChange}
                                        name={"morador"}
                                    />
                                </Grid>
                                <Grid xs={12} md={10}>
                                    <Typography fontSize="13px" fontWeight='400' >Mostrar no APP </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md={3}>
                            <Grid xs={7} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md>
                                    <OneSwitch
                                        defaultValue={initialData?.sindico}
                                        onChange={handleChange}
                                        name={"sindico"}
                                    />
                                </Grid>
                                <Grid xs={12} md={10}>
                                    <Typography fontSize="13px" fontWeight='400' >Mostrar APP Síndico </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md>
                            <Grid xs={7} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md>
                                    <OneSwitch
                                        defaultValue={initialData?.timer_obrigatorio}
                                        onChange={handleChange}
                                        name={"timer_obrigatorio"}
                                    />
                                </Grid>
                                <Grid xs={12} md={10.5}>
                                    <Typography fontSize="13px" fontWeight='400' >Forçar horário p/ desligar no APP </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
                }
            </form>
        </OneModal>
    )
}

export default EdicaoAutomacao

const FooterButtons = () => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="automacao-form" type="submit">Salvar</Button>
        </Grid>
    )
}
